<template>
  <span>
    <strong
      class="capitalize cursor-pointer block outline-none"
      :name="`customer-details-tippy-${user.id}-${anotherKey}`"
    >
      {{ user | fullName }}
    </strong>
    <div class="tooltip-content">
      <TippyContent :to="`customer-details-tippy-${user.id}-${anotherKey}`">
        <div class="p-2">
          <div class="flex justify-between">
            <p class="mr-3 text-gray-600">{{ $t('text.lastName') }}</p>
            <p class="font-medium">{{ user.lastName }}</p>
          </div>
          <div class="flex justify-between mt-3">
            <p class="mr-3 text-gray-600">{{ $t('text.firstName') }}</p>
            <p class="font-medium">{{ user.firstName }}</p>
          </div>
          <div class="flex justify-between mt-3 mb-3">
            <p class="mr-3 text-gray-600">{{ $t('text.phone') }}</p>
            <p class="font-medium">{{ user.phone }}</p>
          </div>
          <hr />
          <div class="flex justify-between mt-3">
            <p class="mr-3 text-gray-600">{{ $t('text.familyName') }}</p>
            <p class="font-medium">{{ user.familyName }}</p>
          </div>
          <div class="flex justify-between mt-3">
            <p class="mr-3 text-gray-600">{{ $t('text.registrationNumber') }}</p>
            <p class="font-medium">{{ user.registrationNumber }}</p>
          </div>
          <div v-if="user.degree" class="flex justify-between mt-3">
            <p class="mr-3 text-gray-600">{{ $t('text.degreeOfEducation') }}</p>
            <p class="font-medium">{{ user.degree.name }}</p>
          </div>
          <div class="flex justify-between mt-3">
            <p class="mr-3 text-gray-600">{{ $t('text.isMarried') }}</p>
            <p class="font-medium">{{ user.isMarried ? $t('text.yes') : $t('text.no') }}</p>
          </div>
          <div class="flex justify-between mt-3">
            <p class="mr-3 text-gray-600">{{ $t('text.familySize') }}</p>
            <p class="font-medium">{{ user.familySize }}</p>
          </div>
          <Button
            :to="{ name: 'CustomerDetails', params: { customerId: user.id } }"
            class="mt-3 w-full border text-gray-700 dark:bg-dark-5 dark:text-gray-300"
          >
            {{ $t('text.seeMore') }}
          </Button>
        </div>
      </TippyContent>
    </div>
  </span>
</template>

<script>
import TippyContent from '@/components/ui/TippyContent';
import Button from '@/components/ui/button/Button';

export default {
  props: {
    user: Object,
    anotherKey: Number,
  },
  components: {
    TippyContent,
    Button,
  },
};
</script>
